exports.f = {}.propertyIsEnumerable;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_object-pie.js
// module id = 70
// module chunks = 10